const getLastParagraph = (htmlString) => {
  const arr = htmlString.split('\n');

  return arr[arr.length - 1];
};

export default getLastParagraph;
